import './PageHero.css';

function PageHero({ title, subtitle, variant = 'default' }) {
  return (
    <section className={`page-hero page-hero-${variant}`}>
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </section>
  );
}

export default PageHero;
